import { useMutation, useQueryClient } from "@tanstack/react-query";
import { pathPickBasketMutationApi } from "@/features/pathpick/features/basket/api/mutation";
import { PathPickSmartStoreInfoRequestBody } from "@/features/pathpick/features/basket/types/request-body";
import { PathPickSmartStoreInfoResponse } from "@/features/pathpick/features/basket/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import { toCamelKeyObject } from "@/utils/case";

// 스마트스토어 기본 정보 등록 — 성공 안내 UI는 호출부가 담당한다.
// 신청 플로우가 저장 직후 관문을 다시 판정하므로 저장된 정보를 그대로 돌려준다.
const useCreateSmartStoreInfo = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: async (body: PathPickSmartStoreInfoRequestBody) => {
      const data = await pathPickBasketMutationApi.createSmartStoreInfo(
        companyId as number,
        body
      );
      return toCamelKeyObject(data) as PathPickSmartStoreInfoResponse;
    },
    // invalidate 대신 캐시를 직접 갱신한다 — 재조회 왕복 동안 옛 값으로 관문이 다시 걸리는 걸 막는다.
    // 응답에서 빠진 필드가 있어도 기존 값을 잃지 않도록 머지한다.
    // (해외 출고지 판정은 주소록 조회 API로 분리돼 이 캐시와 무관하다)
    onSuccess: (saved) => {
      queryClient.setQueryData<PathPickSmartStoreInfoResponse>(
        ["pathpick", "smart-store-info", companyId],
        (previous) => (previous ? { ...previous, ...saved } : saved)
      );
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useCreateSmartStoreInfo;
